import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home.vue'
import SplashScreen from '@/components/layout/SplashScreen'
import Debug from '@/views/Debug'
import QrCode from './views/QrCode.vue'
import Geoloc from './views/Geoloc.vue'

import Auth from '@/middlewares/auth'


// Prevent to display an error on Navigation Duplicated event.
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  });
}

Vue.use(Router)


export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    // Reset to top of the screen on route change
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      beforeEnter: Auth,
      component: Home, /*Layout_login.vue (without sidenav)*/
      meta: {
        gtm: 'Home'
      }
    },
    // {
    //   path: '/splashScreen',
    //   name: 'splashScreen',
    //   component: SplashScreen, /*Layout.vue (with sidenav)*/
    //   meta: {
    //     gtm: 'SplashScreen'
    //   }
    // },
    {
      path: '/debug',
      name: 'debugScreen',
      component: Debug
    },
    {
      path: '/transition/:name',
      name: 'transition',
      component: () => import(/* webpackChunkName: "components" */ './views/Transition.vue')
    },
    // {
    //   path: '/scan',
    //   name: 'qrcode',
    //   beforeEnter: Auth,
    //   component: QrCode,
    //   meta: {
    //     gtm: 'QRCode'
    //   }
    // },
    // {
    //   path: '/locate',
    //   name: 'geoloc',
    //   beforeEnter: Auth,
    //   component : Geoloc,
    //   meta: {
    //     gtm: 'Geoloc'
    //   }
    // },
    /**
     * ------ MASTERCLASS ------
     */
    {
      path: '/theme',
      name: 'themeList',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "lesson" */ './views/masterclass/MasterclassList.vue'),
      meta: {
        gtm: 'Themes',
        breadcrumb: ['home', 'userAccountHome']
      }
    },
    {
      path: '/theme/:themeId',
      name: 'theme',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "lesson" */ './views/masterclass/Theme.vue'),
      meta: {
        gtm: 'Theme',
        breadcrumb: ['home', 'userAccountHome', 'themeList']
      }
    },
    {
      path: '/theme/:themeId/lessonStep/:lessonStepId',
      name: 'lessonStep',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "lesson" */ './views/masterclass/LessonStep.vue'),
      meta: {
        gtm: 'LessonStep'
      }
    },
    {
      path: '/theme/:themeId/lessonStep/:lessonStepId/lesson/:lessonId',
      name: 'lesson',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "lesson" */ './views/masterclass/Lesson.vue'),
      meta: {
        gtm: 'Lesson'
      }
    },
    /**
     * ------ QUIZ ------
     */
    {
      path: '/quiz',
      name: 'quizList',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "quiz" */ './views/quiz/QuizList.vue'),
      meta: {
        gtm: 'Quizzes'
      }
    },
    {
      path: '/quiz/:contentType/:contentId',
      name: 'quiz',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "quiz" */ './views/quiz/Quiz.vue'),
      meta: {
        gtm: 'Quiz'
      }
    },
    {
      path: '/quiz/:contentType/:contentId/question/:questionId',
      name: 'quizQuestion',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "quiz" */ './views/quiz/QuizStep.vue'),
      meta: {
        gtm: 'QuizQuestion'
      }
    },
    {
      path: '/quiz/:contentType/:contentId/result',
      name: 'quizResult',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "quiz" */ './views/quiz/QuizResult.vue'),
      meta: {
        gtm: 'QuizResult'
      }
    },
    {
      path: '/quiz/:contentType/:contentId/wrong-responses',
      name: 'quizWrongResponses',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "quiz" */ './views/quiz/QuizWrongResponses.vue'),
      meta: {
        gtm: 'QuizWrongResponses'
      }
    },
    /**
     * ------ AUTH ------
     */
    {
      path: '/register',
      name: 'register',
      component: () => import(/* webpackChunkName: "auth" */ './views/auth/Register.vue'),
      meta: {
        gtm: 'Register'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "auth" */ './views/auth/Login.vue'),
      meta: {
        gtm: 'Login'
      }
    },
    {
      path: '/reset-password',
      name: 'resetPassword',
      component: () => import(/* webpackChunkName: "auth" */ './views/auth/ResetPassword.vue'),
      meta: {
        gtm: 'ResetPassword'
      }
    },
    {
      path: '/confirm-reset-password',
      name: 'confirmResetPassword',
      component: () => import(/* webpackChunkName: "auth" */ './views/auth/ConfirmResetPassword.vue'),
      meta: {
        gtm: 'ConfirmResetPassword'
      }
    },
    {
      path: '/validate-account',
      name: 'validation-account',
      component: () => import(/* webpackChunkName: "auth" */ './views/auth/ValidateAccount.vue'),
      meta: {
        gtm: 'ValidationAccount'
      }
    },
    {
      path: '/confirm-registration',
      name: 'confirm-registration',
      component: () => import(/* webpackChunkName: "auth" */ './views/auth/ConfirmRegistration.vue'),
      meta: {
        gtm: 'ConfirmRegistration'
      }
    },
    /**
     * ------ USER ACCOUNT ------
     */
    {
      path: '/userAccount',
      name: 'userAccount',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "user" */ './views/userAccount/UserAccount.vue'),
      children: [
        {
          path: '',
          name: 'userAccountHome',
          component: () => import(/* webpackChunkName: "user" */ './views/userAccount/Home.vue'),
          meta: {
            gtm: 'UserAccountHome'
          }
        },
        {
          path: 'personnalInformation',
          name: 'userAccountPersonnalInformation',
          component: () => import(/* webpackChunkName: "user" */ './views/userAccount/PersonnalInformation.vue'),
          meta: {
            gtm: 'UserAccountPersonnalInformation'
          }
        },
        // {
        //   path: 'favoriteWine',
        //   name: 'userAccountFavoriteWine',
        //   component: () => import(/* webpackChunkName: "user" */ './views/userAccount/FavoriteWines.vue'),
        //   meta: {
        //     gtm: 'FavoriteWines'
        //   }
        // },
        {
          path: 'progression',
          name: 'userProgression',
          component: () => import(/* webpackChunkName: "user" */ './views/userAccount/UserProgression.vue'),
          meta: {
            gtm: 'UserProgression'
          }
        },
        {
          path: 'progression/:themeId',
          name: 'userProgressionDetail',
          component: () => import(/* webpackChunkName: "user" */ './views/userAccount/UserProgressionDetail.vue'),
          meta: {
            gtm: 'UserProgressionDetail'
          }
        }
      ]
    },
    /**
     * ------ TASTINGS ------
     */
    {
      path: '/listTasting',
      name: 'listTasting',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "tasting" */ './views/tasting/TastingList.vue'),
      meta: {
        gtm: 'Tastings'
      }
    },
    {
      path: '/tasting',
      name: 'tasting-skeleton',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "tasting" */ './views/tasting/Skeleton.vue'),
      children: [
        {
          path: ':tastingId',
          name: 'tasting-funnel',
          component: () => import(/* webpackChunkName: "tasting" */ './views/tasting/Tasting.vue'),
          meta: {
            gtm: 'TastingDetail'
          }
        },
        {
          path: ':tastingId/section/:sectionId',
          name: 'tasting-section',
          component: () => import(/* webpackChunkName: "tasting" */ './views/tasting/Section.vue'),
          meta: {
            gtm: 'TastingSection'
          },
          children: [
            {
              path: 'step/:stepId',
              name: 'tasting-step',
              component: () => import(/* webpackChunkName: "tasting" */ './views/tasting/Step.vue'),
              meta: {
                gtm: 'TastingStep'
              }
            },
            {
              path: 'summary',
              name: 'section-summary',
              component: () => import(/* webpackChunkName: "tasting" */ './views/tasting/Summary.vue'),
              meta: {
                gtm: 'TastingSummary'
              }
            }
          ]
        },
        {
          path: ':tastingId/rating',
          name: 'tasting-rating',
          component: () => import(/* webpackChunkName: "tasting" */ './views/tasting/Rating.vue'),
          meta: {
            gtm: 'TastingRating'
          }
        }
      ]
    },
    /**
     * ------ SHOP ------
     */
    {
      path: '/cart',
      name: 'cart',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "shop" */ './views/shop/Cart.vue'),
      meta: {
        gtm: 'Cart'
      }
    },
    {
      path: '/cart/informations',
      name: 'CartInformations',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "shop" */ './views/shop/CartInformations.vue'),
      meta: {
        gtm: 'CartInformations'
      }
    },
    {
      path: '/shop/lessons',
      name: 'shop-list-lessons',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "shop" */ './views/shop/ShopListLessons.vue'),
      meta: {
        gtm: 'ShopThemes'
      }
    },
    {
      path: '/shop/bottles',
      name: 'shop-list-bottles',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "shop" */ './views/shop/ShopListBottles.vue'),
      meta: {
        gtm: 'ShopBottles'
      }
    },
    {
      path: '/shop/bottle/:productId',
      name: 'shop-full-bottle',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "shop" */ './views/shop/ShopFullBottle.vue'),
      meta: {
        gtm: 'ShopBotlleDetail'
      }
    },
    {
      path: '/shop/redirect',
      name: 'shop-redirect',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "shop" */ './views/shop/Redirect.vue'),
      meta: {
        gtm: 'ShopRedirect'
      }
    },
    {
      path: '/shop/success',
      name: 'shop-success',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "shop" */ './views/shop/Success.vue'),
      meta: {
        gtm: 'ShopSuccess'
      }
    },
    {
      path: '/shop/:type/:productId',
      name: 'shop-item',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "shop" */ './views/shop/ShopItem.vue'),
      meta: {
        gtm: 'ShopItem'
      }
    }
  ]
})
